import {BaseUserFlow, UserFlowList, UserFlowStep} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class FlightCheckUserFlow extends BaseUserFlow {
  protected type = UserFlowType.FlightCheck;

  /**
   * @inheritdoc
   */
  public setCurrentStep = (newStep: string) => {
    // Setting the current step will override the steps available so only
    // the step being set can be selected.
    this.setSteps([newStep]);
    this.setStep(0);
    return this;
  };

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    super.configure();
    const newSteps = [UserFlowStep.None];

    return newSteps;
  }
}
